import type { NlsKey } from '../nls/strings_nls'

export const PAGE_LABEL_KEYS: Record<string, NlsKey> = {
  dashboard: 'NLSShellRailTileDashboard',
  'for-you': 'NLSMemberTabTodos',
  tasks: 'NLSHelperTabTodos',
  team: 'NLSMemberTabTeam',
  settings: 'NLSShellRailTileSettings',
  'your-page': 'NLSShellRailTileYourPage',
  purchase: 'NLSShellRailTilePurchase',
  board: 'NLSMemberTabBoard',
  nexus: 'NLSMemberTabNexus',
  ai: 'NLSMemberTabAiMagic',
  stock: 'NLSMemberTabStock',
  forms: 'NLSMemberTabForms',
  sync: 'NLSMemberTabSync',
  automations: 'NLSMemberTabAutomations',
  class: 'NLSMemberTabClass',
  field: 'NLSHelperTabField',
  chat: 'NLSHelperTabChat',
  calendar: 'NLSHelperTabCalendar',
  meetings: 'NLSHelperTabMeetings',
  school: 'NLSHelperTabSchool',
  analysis: 'NLSShellRailTileAnalysis',
  reports: 'NLSShellRailTileReports',
  ledger: 'NLSShellRailTileLedger',
  budget: 'NLSShellRailTileBudget',
  quota: 'NLSShellRailTileQuota',
  design: 'NLSShellRailTileDesignHub',
  upload: 'NLSShellRailTileUpload',
  link: 'NLSShellRailTileLink',
  teaching: 'NLSShellRailTileTeaching',
  training: 'NLSShellRailTileTraining',
  todos: 'NLSShellRailTileTodos',
  checklists: 'NLSShellRailTileChecklists',
  focus: 'NLSShellRailTileFocus',
  raid: 'NLSShellRailTileRaid',
  clients: 'NLSShellRailTileClients',
  timesheets: 'NLSShellRailTileTimesheets',
}

export interface PageGroupDefinition {
  id: string
  titleKey: NlsKey
  keys: readonly string[]
}

export const PAGE_GROUPS: readonly PageGroupDefinition[] = [
  {
    id: 'core',
    titleKey: 'NLSControlsGroupCore',
    keys: ['dashboard', 'for-you', 'tasks', 'team', 'settings', 'your-page', 'purchase'] as const,
  },
  {
    id: 'main',
    titleKey: 'NLSControlsGroupMain',
    keys: [
      'board',
      'nexus',
      'ai',
      'stock',
      'forms',
      'sync',
      'automations',
      'class',
      'field',
      'chat',
      'calendar',
      'meetings',
      'school',
    ] as const,
  },
  {
    id: 'web',
    titleKey: 'NLSControlsGroupWeb',
    keys: [
      'analysis',
      'reports',
      'ledger',
      'budget',
      'quota',
      'design',
      'upload',
      'link',
      'teaching',
      'training',
      'todos',
      'checklists',
      'focus',
      'raid',
      'clients',
      'timesheets',
    ] as const,
  },
] as const
